export interface IDataCentroCustos {
    id:number,
    nome: string,
}

export const defValueCentroCusto: IDataCentroCustos = {
    id: 0,
    nome: ""
}